<div class="content map-container">
  <h2>{{id}}'s last location</h2>
  <div id="map" class="map-frame"></div>
</div>